import { transparentize } from "polished";
import React from "react";
import styled, { keyframes, css } from "styled-components";

const skChase = keyframes`
  100% { transform: rotate(360deg); } 
`;

const skChaseDot = keyframes`
  80%, 100% { transform: rotate(360deg); } 
`;

const skChaseDotBefore = keyframes`
  50% {
    transform: scale(0.4); 
  } 100%, 0% {
    transform: scale(1.0); 
  } 
`;

type WrapperProps = {
  overlay?: boolean;
};

type ContainerProps = {
  small?: boolean;
};

type DotProps = {
  color?: string;
};

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  ${(props) =>
    props.overlay &&
    css`
      left: 0;
      top: 0;
      position: absolute;
      background: ${(props) => transparentize(0.5, props.theme.colors.bg)};
      z-index: 10000;
    `}
`;

const Container = styled.div<ContainerProps>`
  width: ${(props) => (props.small ? 40 : 80)}px;
  height: ${(props) => (props.small ? 40 : 80)}px;
  margin: ${(props) => (props.small ? 20 : 40)}px auto;
  position: relative;
  animation: ${skChase} 2.5s infinite linear both;
`;

const Dot = styled.div<DotProps>`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: ${skChaseDot} 2s infinite ease-in-out both;

  &:before {
    content: "";
    display: block;
    width: 25%;
    height: 25%;
    background-color: ${(props) =>
      props.theme.colors[props.color || "primary"]};
    border-radius: 100%;
    animation: ${skChaseDotBefore} 2s infinite ease-in-out both;
  }
  &:nth-child(1) {
    animation-delay: -1.1s;
  }
  &:nth-child(2) {
    animation-delay: -1s;
  }
  &:nth-child(3) {
    animation-delay: -0.9s;
  }
  &:nth-child(4) {
    animation-delay: -0.8s;
  }
  &:nth-child(5) {
    animation-delay: -0.7s;
  }
  &:nth-child(6) {
    animation-delay: -0.6s;
  }
  &:nth-child(1):before {
    animation-delay: -1.1s;
  }
  &:nth-child(2):before {
    animation-delay: -1s;
  }
  &:nth-child(3):before {
    animation-delay: -0.9s;
  }
  &:nth-child(4):before {
    animation-delay: -0.8s;
  }
  &:nth-child(5):before {
    animation-delay: -0.7s;
  }
  &:nth-child(6):before {
    animation-delay: -0.6s;
  }
`;

Dot.defaultProps = {
  color: "primary",
};

type LoaderProps = ContainerProps & WrapperProps & DotProps;

const Loader = ({ overlay, small, color }: LoaderProps) => (
  <Wrapper overlay={overlay}>
    <Container small={small}>
      <Dot color={color} />
      <Dot color={color} />
      <Dot color={color} />
      <Dot color={color} />
      <Dot color={color} />
      <Dot color={color} />
    </Container>
  </Wrapper>
);

export default Loader;
